import { getRequest, putRequest, postRequest, deleteRequest } from "./request";
export const loginApi = function() {}
loginApi.prototype = {

    /* 发送验证码 */
    async getCode(tel) {
        let res = await getRequest(`/sobuyLoginProof/getcode/${tel}`)
        return res
    },
    /* 验证手机验证码 */
    async verifyCode(info) {
        let res = await getRequest(`/sobuyLoginProof/verifyCode`, info)
        if (res.success) {
            return res
        }

    },
    /* 登陆 */
    async login(tel) {
        let res = await postRequest(`/sobuyLoginProof/login`, tel)
        return res
    },
    /*获取schemeURL*/
    async getJumpSchemeURL() {
        let res = await getRequest(`/wxLogin/getSchemeUrl`)
        return res
    }
}

export const productApi = function() {}
productApi.prototype = {

    /* 手机端获取收货信息 */
    async getSignInfo(proofId) {
        let res = await getRequest(`/sobuyProof/getSignInfo/${proofId}`)
        return res.data.proInfo
    },
    /* 确认收货 */
    async signSample(proofId) {
        let res = await putRequest(`/sobuyProof/signSample/${proofId}`)
        return res

    },
    /* 获取权限 */
    async sobuyGetInfo() {
        let res = await getRequest(`/sobuyGetInfo`)
        return res.data.userInfo.permissions
    },

}